import { api } from './api'

export type ContactMessageStatus = 'new' | 'read' | 'resolved'

export type PlatformContactMessage = {
  id: number
  senderName: string
  senderEmail: string
  body: string
  locale: string | null
  status: ContactMessageStatus
  handledAt: string | null
  createdAt: string
}

export type PlatformContactList = {
  items: PlatformContactMessage[]
  total: number
  unread: number
  page: number
  limit: number
}

function assertSuccess<T>(body: unknown): T {
  const b = body as { success?: boolean; message?: string; data?: T }
  if (!b?.success) throw new Error(b?.message || 'Request failed')
  return b.data as T
}

function apiError(err: unknown, fallback: string) {
  const e = err as { response?: { data?: { message?: string } }; message?: string }
  return new Error(e?.response?.data?.message || e?.message || fallback)
}

export async function fetchContactMessages(params?: {
  page?: number
  limit?: number
  status?: ContactMessageStatus
}): Promise<PlatformContactList> {
  try {
    const { data } = await api.get('/admin/platform/contact-messages', { params })
    return assertSuccess<PlatformContactList>(data)
  } catch (e) {
    throw apiError(e, 'Failed to load messages')
  }
}

export async function setContactMessageStatus(
  id: number,
  status: ContactMessageStatus,
): Promise<PlatformContactMessage> {
  try {
    const { data } = await api.patch(`/admin/platform/contact-messages/${id}`, { status })
    return assertSuccess<PlatformContactMessage>(data)
  } catch (e) {
    throw apiError(e, 'Failed to update message')
  }
}
